function applyFilters(filtersToApply, plans) {
  for (const filter of filtersToApply) {
    if (!filter(plans)) {
      return false
    }
  }

  return true
}

export default applyFilters
